(function () {
    const addText = "Add";
    const updateText = "Update";

    class ManageCampaignTemplateMenuscriptsController {
        /**
         * @type {CampaignMenuscriptTemplate}
         */
        menuscript;
        /**
         * @type {CampaignTemplate}
         */
        campaignTemplate;

        /**
         * @type {RoleContext}
         */
        userContext;

        hasMenuscripts = false;

        constructor(
            $scope,
            $compile,
            DTOptionsBuilder,
            DTColumnBuilder,
            $q,
            CampaignDesignerService,
            ErrorService,
            notify,
            $state,
            renderer
        ) {
            this.$scope = $scope;
            this.$compile = $compile;
            this.DTOptionsBuilder = DTOptionsBuilder;
            this.DTColumnBuilder = DTColumnBuilder;
            this.$q = $q;
            this.CampaignDesignerService = CampaignDesignerService;
            this.ErrorService = ErrorService;
            this.notify = notify;
            this.$state = $state;
            this.renderer = renderer;
        }

        $onInit() {
            this.grid = {
                hasError: false
            };

            this.hasMenuscripts = this.campaignTemplate &&
                this.campaignTemplate.MenuScripts &&
                !!this.campaignTemplate.MenuScripts.length;

            this.setupGrid();
            this.resetMenuscript();
        }

        saveMenuscript() {
            this.$scope.$root.isLoading = true;
            this.menuscript.CampaignTemplateId = this.campaignTemplate.Id;

            const validationPassed = this.menuscript.Validate(this.ErrorService);

            if (!validationPassed) {
                return;
            }

            this.CampaignDesignerService.saveCampaignTemplateMenuscript(
                this.campaignTemplate.TemplateGuid,
                this.menuscript
            ).then(result => {
                    this.menuscript.Id = result.data;

                    const existingMenuscript = this.campaignTemplate.MenuScripts.find(
                        menuscript => menuscript.Id === result.data
                    );

                    if (!existingMenuscript) {
                        this.campaignTemplate.MenuScripts.push(this.menuscript);
                    } else {
                        this.campaignTemplate.MenuScripts.forEach((menuscript, index, origArray) => {
                            if (menuscript.Id === result.data) {
                                origArray[index] = this.menuscript;
                            }
                        });
                    }

                    this.resetMenuscript();
                    this.grid.dtInstance.rerender();
                    this.notify.success("The campaign menu script was successfully added");
                }
            ).catch(err => {
                this.ErrorService.showError(
                    "An error occurred while saving the menu script",
                    err
                );
            }).finally(() => {
                this.$scope.$root.isLoading = false;
            });
        }

        resetMenuscript() {
            this.menuscript = new Dashboard.Models.CampaignMenuscriptTemplate();
            this.AddButtonText = addText;
        }

        goPrevious() {
            return this.beforeNavigation()
                .then(() => {
                    this.$state.go(
                        Dashboard.helpers.stateHelper.getParentState(
                            this.$state.current.name
                        ) + ".comms", {
                            brandId: this.userContext.BrandId,
                            CampaignTemplateGuid: this.campaignTemplate.TemplateGuid
                        });
                });
        }

        goNext() {
            return this.beforeNavigation()
                .then(() => {
                    this.$state.go(
                        Dashboard.helpers.stateHelper.getParentState(
                            this.$state.current.name
                        ) + ".confirm", {
                            brandId: this.userContext.BrandId,
                            CampaignTemplateGuid: this.campaignTemplate.TemplateGuid
                        });
                });
        }

        beforeNavigation() {
            if (this.navigationCancelledByUser()) {
                return this.rejectedQ();
            }
            return this.removeAllMenuScriptsIfRequired();
        }

        rejectedQ() {
            const d = this.$q.defer();
            d.reject();
            return d.promise;
        }

        resolvedQ() {
            const d = this.$q.defer();
            d.resolve();
            return d.promise;
        }

        removeAllMenuScriptsIfRequired() {
            if (this.hasMenuscripts) {
                const d = this.$q.defer();
                d.resolve();
                return d.promise;
            }

            const deferred = this.$q.defer();
            let promise = deferred.promise;
            for (const menuScript of this.campaignTemplate.MenuScripts) {
                promise = promise.then(() =>
                    this.CampaignDesignerService.removeCampaignTemplateMenuscript(
                        this.campaignTemplate.TemplateGuid,
                        menuScript.Id
                    ).catch(err => {
                            this.ErrorService.showError(
                                `Unable to remove menuscript #${menuScript.Id}: ${err}`,
                                err
                            );
                            throw err;
                        }
                    )
                );
            }
            promise.then(() => this.campaignTemplate.MenuScripts.splice(
                0, this.campaignTemplate.MenuScripts.length
            ));
            deferred.resolve();
            return promise;
        }

        navigationCancelledByUser() {
            const
                menuscriptCount = this.campaignTemplate.MenuScripts.length,
                s = menuscriptCount === 1 ? "" : "s",
                deferential = menuscriptCount === 1 ? "it" : "them";
            if (!this.hasMenuscripts && !!menuscriptCount) {
                return !window.confirm(`
This campaign template has ${menuscriptCount} associated menu script${s}.

Are you sure you would like to discard ${deferential}?
`.trim());
            }
            return false;
        }

        /**
         * @param {number} menuscriptId
         */
        setEditMenuscript(menuscriptId) {
            const menuscriptToEdit = this.campaignTemplate.MenuScripts.find(
                menuscript => menuscript.Id === menuscriptId
            );

            this.menuscript = new Dashboard.Models.CampaignMenuscriptTemplate()
                .initialiseCampaignMenuscriptTemplate(menuscriptToEdit);

            this.AddButtonText = updateText;
        }

        /**
         * Removes the menuscript
         */
        removeMenuscript(menuscriptId) {
            this.$scope.$root.isLoading = true;

            this.removeMenuscriptAtBackend(
                menuscriptId
            ).then(() => {
                    this.campaignTemplate.MenuScripts = _.reject(
                        this.campaignTemplate.MenuScripts,
                        menuscript => menuscript.Id === menuscriptId
                    );
                    this.grid.dtInstance.rerender();

                    this.notify.success(
                        "The campaign menu script was successfully removed"
                    );
                }
            ).catch(err => {
                this.ErrorService.showError(
                    "An error occurred while removing the menu script",
                    err);
            }).finally(() => {
                this.$scope.$root.isLoading = false;
            });
        }

        removeMenuscriptAtBackend(menuscriptId) {
            return this.CampaignDesignerService.removeCampaignTemplateMenuscript(
                this.campaignTemplate.TemplateGuid,
                menuscriptId
            );
        }


        /**
         * Setup the finished campaigns grid
         */
        setupGrid() {
            this.grid.dtOptions = this.DTOptionsBuilder
                .fromFnPromise(this.getTableData.bind(this))
                .withOption("paging", true)
                .withOption("searching", true)
                .withOption("processing", true)
                .withPaginationType("full_numbers")
                .withOption("responsive", true)
                .withOption("order", [ [ 1, "desc" ] ])
                .withOption("createdRow", row => {
                    // Recompiling so we can bind Angular directive to the DT
                    this.$compile(angular.element(row).contents())(this.$scope);
                });

            this.grid.dtColumns = [
                this.DTColumnBuilder.newColumn("Name").withTitle("Name").withOption("width", "50px"),
                this.DTColumnBuilder.newColumn("MenuScriptGuid").withTitle("Menu Script Guid").withOption("width", "50px"),
                this.DTColumnBuilder.newColumn("EstimatedDiscount").withTitle("Estimated Discount").withOption("width", "50px"),
                this.DTColumnBuilder.newColumn("Id").withTitle("Options").renderWith(this.renderer.safeRender((data, type, full) => {
                    const html = _.template("<a ng-click=\"$ctrl.setEditMenuscript({0})\"> <i class=\"fa fa-edit\" aria-hidden=\"true\" ></i></a>&nbsp;<a  ng-show=\"$ctrl.campaignTemplate.IsDraft()\" ng-click=\"$ctrl.removeMenuscript({0})\"> <i class=\"fa fa-trash\" aria-hidden=\"true\" ></i></a>".format(data))(full);
                    return html;
                })).withOption("width", "50px")
                    .withOption("orderable", false)
            ];
            this.grid.dtInstance = null;
        }

        /**
         * Gets the table data
         */
        getTableData() {
            const deferred = this.$q.defer();
            deferred.resolve(this.campaignTemplate.MenuScripts);
            return deferred.promise;
        }
    }

    angular
        .module(
            "dashboard"
        )
        .component(
            "manageCampaignTemplateMenuscripts"
            , {
                templateUrl: "components/campaigndesigner/managecampaigntemplates/menuscriptssetup/campaigntemplatemenuscriptssetup.b709b45d.html"
                ,
                bindings: {
                    campaignTemplate: "=",
                    userContext: "<"
                }
                ,
                controller: [
                    "$scope",
                    "$compile",
                    "DTOptionsBuilder",
                    "DTColumnBuilder",
                    "$q",
                    "CampaignDesignerService",
                    "ErrorService",
                    "notify",
                    "$state",
                    "DataTablesRenderer",
                    ManageCampaignTemplateMenuscriptsController ]
            }
        )
    ;
})
();
